// pointMultiplier.js
export const calculatePointMultiplier = () => {
    const now = new Date();
    const hour = now.getHours();
    const day = now.getDay(); // 0 = Sunday, 6 = Saturday
    
    let multiplier = 1.0;
    
    // Night owl bonus (10pm - 2am)
    if (hour >= 22 || hour < 2) {
      multiplier += 0.5; // 50% bonus
    }
    
    // Weekend bonus
    if (day === 0 || day === 6) {
      multiplier += 0.25; // 25% bonus
    }
    
    // Peak hours (prime time 7pm-10pm)
    if (hour >= 19 && hour < 22) {
      multiplier += 0.2; // 20% bonus
    }
    
    return {
      multiplier,
      isNightOwl: (hour >= 22 || hour < 2),
      isWeekend: (day === 0 || day === 6),
      isPeakHours: (hour >= 19 && hour < 22)
    };
  };